import type { OwnProps, StateProps } from 'components/common-form/sidePanel/info/QuoteInfos/QuoteInfos.connect';
import { connect } from 'react-redux';
import * as addonSelector from 'state/addonForm/addonForm.selector';
import { getIsUserInternal } from 'state/selectors/common/user';
import { hasProductDumpDetails } from 'state/selectors/meta/quote/utils';
import type { AppState } from 'state/state.model';

const mapStateToProps = (state: AppState, { tabId, workspaceType }: OwnProps): StateProps => {
  const quoteId = addonSelector.getLastQuoteId(state, tabId);
  const quoteResult = addonSelector.getQuoteResult(state, quoteId);
  const externalQuoteId = addonSelector.getLastQuoteExternalId(state, tabId) ?? quoteResult?.quoteExternalId!;

  const quoteDetails = addonSelector.getQuoteDetails(state, tabId);
  const isInternalUser = getIsUserInternal(state);

  return {
    isInternalUser: isInternalUser,
    hasDetails: quoteDetails !== undefined || externalQuoteId !== undefined,
    hasProductDump: hasProductDumpDetails(state, workspaceType, tabId),
    externalQuoteId: externalQuoteId,
    quoteDetails: quoteDetails,
    quoteId: quoteId!,
  };
};

export const connectQuoteInfos = connect(mapStateToProps);
